<div>

    @if (isTitleShown) {
        <div class="row alert ">
            <h1 class="wp-header-text">{{title}}</h1>
        </div>
    }

    <br/>

    @if (isSubtitleShown) {
        <div class="row alert ">
            <h3 class="wp-header-text">{{subtitle}} {{enrollmentButtonsText}}</h3>
        </div>
    }

    <br/>

    <div class="btn-group mr-2" role="group" aria-label="Basic example">
        @for (item of enrollmentButtons; track item) {
            <div class="btn">
                <a  href="{{item.enrollmentLinkUrl}}">
                    <img class="img-fluid mx-auto" src="{{item.enrollmentButtonUrl}}" >
                    <!-- <img  src="{{item.enrollmentButtonUrl}}" > -->
                </a>
            </div>
        } @empty {
    
        }
    
    </div>

</div>    